
<mat-progress-spinner
    class="spinner"
    color="accent"
    mode="indeterminate"
    diameter="40"
    value="25">
</mat-progress-spinner>
